import manifestJson from '../../public/manifest.json'

export const version = manifestJson.data.version
console.log('version', version)
export const terminalKey = {
  default: {
    product: 'connect-h5',
    version,
    key: '657dpw0930a54k239fcka7c1sd83jd1d'
  },
  live: {
    product: 'connect-h5',
    version,
    key: '8gn173n4m548cds913c3495mqo8cqw30'
  }
}

export const encrytedContentType = 'text/encrypted;aver=1'
export const ENCRYTEDCONTENTTYPE2 = 'text/encrypted;'
